import { useMediaQuery, useTheme } from '@mui/material';

export const useBreakpoint = () => {
    const theme = useTheme();

    const isMobile = useMediaQuery(theme.breakpoints.between('xs', 'sm'));
    const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'lg'));
    const isDesktop = useMediaQuery(theme.breakpoints.between('lg', 'xl'));
    const isLargeDesktop = useMediaQuery(theme.breakpoints.up('xl'));

    return { isMobile, isTablet, isDesktop, isLargeDesktop };
};
